export default "__VITE_ASSET__D4L$pbHu__"